export const capacityTranslationsEn = {
  currentPeak: 'Current peak: {n}',
  numOfOrders: 'Number of activities',
  numOfWorkers: 'Number of workers',
  resources: 'Resources',
  showResourceCurve: 'Show resource curve',
  siteThreshold: 'Site threshold: {n}',
  siteThresholdExceeded: 'Site threshold of {n} exceeded',
  toggleResourceCurve: 'Toggle resource curve',
};
